import React, { Component } from 'react'
import { connect } from 'react-redux'
import { fetchHousingData, fetchPipelineData, uploadFile, clearUploadErrors, fetchAgencyList, fetchHousingNPUData } from 'store/modules/housing/actions'
import { checkAuth } from 'store/modules/auth/actions'
import DashboardComponent from 'bundles/Dashboard/components/DashboardComponent';
import Loader from 'shared/components/Loader'


class DashboardContainer extends Component {

    async componentDidMount() {
        const { housingData, loggedIn, fetchHousingData,fetchPipelineData, checkAuth, pipelineData } = this.props;

        if (!loggedIn) {
            checkAuth();
        }

        if (!housingData) {
            fetchHousingData();
        }

        if (!pipelineData) {
            fetchPipelineData();
        }

       
    }

    render() {
        const { isFetchingHousingData,isFetchingPipelineData } = this.props;

        return (
            isFetchingHousingData |  isFetchingPipelineData ? (
                <div className="body-center vertical">
                    <Loader />
                </div>
            ) : (
                <DashboardComponent
                    {...this.props}
                />
            )
        )
    }
}

const mapStateToProps = (state) => {

    return {
        housingData: state.housing.housingData,
        pipelineData: state.housing.pipelineData,
        isFetchingHousingData: state.housing.isFetchingHousingData,
        isFetchingPipelineData: state.housing.isFetchingPipelineData,
        loggedIn: state.auth.loggedIn,
        user: state.auth.user,
        uploadData: state.housing.uploadData,
        isUploading: state.housing.isUploading,
        uploadError: state.housing.uploadError,
        agencyList: state.housing.agencyList,
        housingNPUData:state.housing.housingNPUData
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchPipelineData: () => {
            dispatch(fetchPipelineData())
        },
        fetchHousingData: () => {
            dispatch(fetchHousingData())
        },
        
        checkAuth: () => {
            dispatch(checkAuth())
        },
        uploadFile: (file) => {
            dispatch(uploadFile(file))
        },
        clearUploadErrors: () => {
            dispatch(clearUploadErrors())
        },
        fetchAgencyList: () => {
            dispatch(fetchAgencyList())
        },
        fetchHousingNPUData: (geojson) => {
            dispatch(fetchHousingNPUData(geojson))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardContainer)
